import { QuestionApiMapper, SectionApiMapper, FormApiMapper, FormSummaryApiMapper, GlobalFormApiMapper, SpaceApiMapper, ESSAY_QUESTION_API, EssayQuestionApi, FILL_IN_BLANK_QUESTION_API, FillInBlankQuestionApi, FOLDER_API, FolderApi, FORM_API, FORM_CATEGORY_API, FormApi, FormCategoryApi, MATCHING_QUESTION_API, MatchingQuestionApi, SPEAKING_QUESTION_API, SpeakingQuestionApi, MULTIPLE_CHOICE_QUESTION_API, MultipleChoiceQuestionApi, QUESTION_API, QuestionApi, SINGLE_CHOICE_QUESTION_API, SingleChoiceQuestionApi, SPACE_SEARCH_API, SpaceObjectsApi, TAG_API, TagApi, QUESTION_RELEASES_API, QuestionReleasesApi, GLOBAL_FORM_API, GlobalFormApi } from './data-sources';
import { AxiosInstanceBuilder } from '@digibricks/plugin-axios';
import { FORM_REPOSITORY_WEB_CONFIG } from './form-repository-web.config';
import { FormReleaseMapper } from './repositories';
export var apiProviders = [{
  provide: QuestionApiMapper,
  useValue: new QuestionApiMapper()
}, {
  provide: SectionApiMapper,
  useValue: new SectionApiMapper()
}, {
  provide: FormApiMapper,
  useFactory: function useFactory(sectionApiMapper) {
    return new FormApiMapper(sectionApiMapper);
  },
  inject: [SectionApiMapper]
}, {
  provide: FormSummaryApiMapper,
  useFactory: function useFactory() {
    return new FormSummaryApiMapper();
  },
  inject: []
}, {
  provide: GlobalFormApiMapper,
  useValue: new GlobalFormApiMapper()
}, FormReleaseMapper, {
  provide: AxiosInstanceBuilder,
  useFactory: function useFactory(config) {
    return new AxiosInstanceBuilder().withBaseUrl(config.baseUrl).withTimeout(config.timeout).withHeaders({
      Authorization: "Bearer ".concat(config.accessToken)
    });
  },
  inject: [FORM_REPOSITORY_WEB_CONFIG]
}, {
  provide: FORM_API,
  useFactory: function useFactory(sectionApiMapper, formApiMapper, formSummaryApiMapper, axiosInstanceBuilder, config) {
    var planClient = new AxiosInstanceBuilder().withTimeout(config.timeout).withHeaders({
      Authorization: "Bearer ".concat(config.accessToken)
    }).toInstance();
    return new FormApi(axiosInstanceBuilder.toInstance(), sectionApiMapper, formApiMapper, formSummaryApiMapper, planClient);
  },
  inject: [SectionApiMapper, FormApiMapper, FormSummaryApiMapper, AxiosInstanceBuilder, FORM_REPOSITORY_WEB_CONFIG]
}, {
  provide: FOLDER_API,
  useFactory: function useFactory(axiosInstanceBuilder) {
    return new FolderApi(axiosInstanceBuilder.toInstance());
  },
  inject: [AxiosInstanceBuilder]
}, {
  provide: QUESTION_API,
  useFactory: function useFactory(questionApiMapper, axiosInstanceBuilder) {
    return new QuestionApi(axiosInstanceBuilder.toInstance(), questionApiMapper);
  },
  inject: [QuestionApiMapper, AxiosInstanceBuilder]
}, {
  provide: QUESTION_RELEASES_API,
  useFactory: function useFactory(axiosInstanceBuilder) {
    return new QuestionReleasesApi(axiosInstanceBuilder.toInstance());
  },
  inject: [AxiosInstanceBuilder]
}, {
  provide: FILL_IN_BLANK_QUESTION_API,
  useFactory: function useFactory(questionApiMapper, axiosInstanceBuilder) {
    return new FillInBlankQuestionApi(axiosInstanceBuilder.toInstance(), questionApiMapper);
  },
  inject: [QuestionApiMapper, AxiosInstanceBuilder]
}, {
  provide: SINGLE_CHOICE_QUESTION_API,
  useFactory: function useFactory(questionApiMapper, axiosInstanceBuilder) {
    return new SingleChoiceQuestionApi(axiosInstanceBuilder.toInstance(), questionApiMapper);
  },
  inject: [QuestionApiMapper, AxiosInstanceBuilder]
}, {
  provide: MULTIPLE_CHOICE_QUESTION_API,
  useFactory: function useFactory(questionApiMapper, axiosInstanceBuilder) {
    return new MultipleChoiceQuestionApi(axiosInstanceBuilder.toInstance(), questionApiMapper);
  },
  inject: [QuestionApiMapper, AxiosInstanceBuilder]
}, {
  provide: ESSAY_QUESTION_API,
  useFactory: function useFactory(questionApiMapper, axiosInstanceBuilder) {
    return new EssayQuestionApi(axiosInstanceBuilder.toInstance(), questionApiMapper);
  },
  inject: [QuestionApiMapper, AxiosInstanceBuilder]
}, {
  provide: MATCHING_QUESTION_API,
  useFactory: function useFactory(questionApiMapper, axiosInstanceBuilder) {
    return new MatchingQuestionApi(axiosInstanceBuilder.toInstance(), questionApiMapper);
  },
  inject: [QuestionApiMapper, AxiosInstanceBuilder]
}, {
  provide: SPEAKING_QUESTION_API,
  useFactory: function useFactory(questionApiMapper, axiosInstanceBuilder) {
    return new SpeakingQuestionApi(axiosInstanceBuilder.toInstance(), questionApiMapper);
  },
  inject: [QuestionApiMapper, AxiosInstanceBuilder]
}, {
  provide: SpaceApiMapper,
  useFactory: function useFactory() {
    return new SpaceApiMapper();
  },
  inject: []
}, {
  provide: SPACE_SEARCH_API,
  useFactory: function useFactory(axiosInstanceBuilder, spaceApiMapper) {
    return new SpaceObjectsApi(axiosInstanceBuilder.toInstance(), spaceApiMapper);
  },
  inject: [AxiosInstanceBuilder, SpaceApiMapper]
}, {
  provide: TAG_API,
  useFactory: function useFactory(axiosInstanceBuilder) {
    return new TagApi(axiosInstanceBuilder.toInstance());
  },
  inject: [AxiosInstanceBuilder]
}, {
  provide: FORM_CATEGORY_API,
  useFactory: function useFactory(axiosInstanceBuilder) {
    return new FormCategoryApi(axiosInstanceBuilder.toInstance());
  },
  inject: [AxiosInstanceBuilder]
}, {
  provide: GLOBAL_FORM_API,
  useFactory: function useFactory(axiosInstanceBuilder, globalFormApiMapper) {
    return new GlobalFormApi(axiosInstanceBuilder.toInstance(), globalFormApiMapper);
  },
  inject: [AxiosInstanceBuilder, GlobalFormApiMapper]
}];